import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

interface Step {
  label: string;
  match: string;
}

export enum StepMatch {
  WorkItOut = 'work-it-out',
  PickAPlan = 'pick-a-plan',
  ContactDetails = 'contact-details',
  CompanyDetails = 'company-details',
  PayrollInformation = 'payroll-information',
  Summary = 'summary',
}

const STEPS: Step[] = [
  {
    label: 'Work it out',
    match: StepMatch.WorkItOut,
  },
  {
    label: 'Pick a plan',
    match: StepMatch.PickAPlan,
  },
  {
    label: 'Contact details',
    match: StepMatch.ContactDetails,
  },
  {
    label: 'Company details',
    match: StepMatch.CompanyDetails,
  },
  {
    label: 'Payroll information',
    match: StepMatch.PayrollInformation,
  },
  {
    label: 'Summary',
    match: StepMatch.Summary,
  },
];

interface FlowProgressHeaderProps {
  flowMatch: StepMatch;
}

export const FlowProgressHeader = ({ flowMatch }: FlowProgressHeaderProps) => (
  <>
    <div className="FlowProgressHeader">
      <div className="Container">
        <ul className="FlowProgressHeader-list">
          {STEPS.map(({ label, match }, index) => {
            const stepIndex = `${index + 1}.`;
            const isActive = match === flowMatch;
            const isDisabled = STEPS.findIndex((step) => step.match === flowMatch) < index;

            const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
              if (isDisabled) {
                e.preventDefault();
                e.stopPropagation();
              }
            };

            return (
              <li
                className={classNames('FlowProgressHeader-item', {
                  isActive,
                  isDisabled,
                })}
                key={match}
              >
                <Link to={`/sign-up/${match}`} onClick={(e) => handleClick(e)}>
                  {stepIndex}
                  <span
                    className={classNames('FlowProgressHeader-item-label', {
                      isActive,
                    })}
                  >
                    {label}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>

    <div className="FlowProgressHeader-title">
      <h1>
        <FormattedMessage id="GET_STARTED" />
      </h1>
    </div>
  </>
);
